import React from "react";

function Home() {
  const APKUrl =
    "https://play.google.com/store/apps/details?id=com.mouadz.geekun";
  const IOSUrl =
    "https://apps.apple.com/us/app/id1629443150";

  return (
    <div>
      <div className="home">
        <div className="logo" />

        <p className="get-geekun">Download Geekun Now!</p>

        <p className="get-geekun-desc">
          Find the anime behind any image! Scan & discover with Geekun.
        </p>

        <div className="store-buttons">
          <a
            target="_blank"
            rel="noreferrer"
            href={APKUrl}
            className="google-play"
          >
            {" "}
          </a>
          <a
            target="_blank"
            rel="noreferrer"
            href={IOSUrl}
            className="app-store"
          >
            {" "}
          </a>
        </div>
      </div>
    </div>
  );
}

export default Home;
